import { React, useState, useEffect } from 'react';
import { useNavigate, useLocation ,Link} from 'react-router-dom';

import urls, { getCsrfToken } from '../com.zedock.common.script/urls.js';
import { clicks } from '../com.zedock.common.script/common.js';

import '../com.zedock.common.style/SignUp.css';
import '../com.zedock.common.style/common.css';

function SignUp() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showDiv, setShowDiv] = useState(false);
  const [showErr, setShowErr] = useState(false);
  const [step, setStep] = useState(1);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");

  useEffect(() => {
    clicks(location.pathname);
  }, []);

  const getOTPSignUp = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const response = await fetch(`${urls.BASE_URL}/signup/forgot-password`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-XSRF-TOKEN': getCsrfToken()
        },
        body: JSON.stringify({ email })
      });
      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        if (data.responseData === 'true') {
          setMsg("OTP send to Email ID.");
          setShowDiv(true);
          setTimeout(() => {
            setShowDiv(false);
          }, 5000);
          setStep(2);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };


  const validateOTPSignUp = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const response = await fetch(`${urls.BASE_URL}/forgot/verify-otp`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-XSRF-TOKEN': getCsrfToken()
        },
        body: JSON.stringify({ email, otp })
      });

      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        if (data.responseData === 'true') {
          setMsg("OTP validated successfully");
          setShowDiv(true);
          setTimeout(() => {
            setShowDiv(false);
          }, 2000);
          setStep(3);
        }
        else {
          setMsg("Invalid OTP entered");
          setShowErr(true);
          setTimeout(() => {
            setShowErr(false);
          }, 2000);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    try {
      const response = await
        fetch(`${urls.BASE_URL}` + "/signup", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": getCsrfToken()
          },

          body: JSON.stringify({
            "email": email,
            "password": password,
            "repassword": repassword,
            "otp": otp
          })
        });

      const res = await response.text();
      if (res == "false") {
        setMsg("Email already exits... Please click on reset password.");
        setShowDiv(true);
        setTimeout(() => {
          setShowDiv(false);
        }, 5000);
      }
      else {
        navigate("/Login")
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
    }
  };

  return (
    <div className="container px-0    ">

      <div className="zd-wrap px-2 px-lg-4 py-3">

        <div className="row m-1">
          <nav aria-label="breadcrumb" className="zd-crumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link href="" onClick={(e) => { e.preventDefault();navigate("/Product")}}>Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">Sign Up</li>
            </ol>
          </nav>
        </div>

        <div className="row justify-content-center m-1">
          <div className="col-12 col-lg-10">
            <div className="zd-auth-shell row g-0">

              {/* form side */}
              <div className="col-12 col-lg-6">
                <div className="zd-auth-form">
                  <span className="zd-auth-eyebrow">Join Zedock</span>
                  <h2>Create your account</h2>
                  <p className="zd-auth-sub">Sign up for early access to new arrivals and member-only offers.</p>

                  {step == 1 && (
                    <form onSubmit={getOTPSignUp}>
                      <div className="zd-field">
                        <label htmlFor="exampleInputEmail1">Email ID</label>
                        <input
                          type="email"
                          className="form-control"
                          id="exampleInputEmail1"
                          placeholder="you@example.com"
                          aria-describedby="emailHelp"
                          required
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <button type="submit" className="zd-submit" disabled={loading}>
                        {loading ? 'Sending OTP...' : 'Get OTP'}
                      </button>
                    </form>
                  )}

                  {step == 2 && (
                    <form onSubmit={validateOTPSignUp}>

                      <div className="zd-field">
                        <label htmlFor="exampleInputEmail1">Enter OTP</label>
                        <input
                          type="text"
                          inputMode="numeric"
                          maxLength={6}
                          className="form-control"
                          id="otpInput"
                          placeholder="6-digit code"
                          required
                          value={otp}
                          onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                        />
                      </div>
                      <button type="submit" className="zd-submit" disabled={loading}>
                        {loading ? 'Validating OTP...' : 'Validate OTP'}
                      </button>
                    </form>
                  )}

                  {step == 3 && (
                    <form onSubmit={handleSignUp}>

                      <div className="zd-field">
                        <label htmlFor="exampleInputPassword1">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          id="exampleInputPassword1"
                          placeholder="Create a password"
                          required
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>

                      <div className="zd-field">
                        <label htmlFor="exampleInputPassword2">Re-enter Password</label>
                        <input
                          type="password"
                          className="form-control"
                          id="exampleInputPassword2"
                          placeholder="Confirm your password"
                          required
                          value={repassword}
                          onChange={(e) => setRepassword(e.target.value)}
                        />
                      </div>

                      <div className="zd-remember">
                        <input type="checkbox" id="exampleCheck1" />
                        <label htmlFor="exampleCheck1">Remember me</label>
                      </div>
                      <button type="submit" className="zd-submit">Sign Up</button>
                    </form>
                  )}

                  {showDiv && (
                    <div className="zd-alert zd-alert-success">{msg} </div>
                  )}

                  {showErr && (
                    <div className="zd-alert zd-alert-error">{msg} </div>
                  )}

                  <p className="zd-alt-action">
                    Already have an account? <Link href="" onClick={(e) => { e.preventDefault();navigate("/Login", { state: { from: location } })}}>Log in   </Link>

                  </p>

                </div>
              </div>

              {/* image side */}
              <div className="col-12 col-lg-6 d-none d-lg-block">
                <div className="zd-auth-visual h-100">
                  <img
                    src={urls.CDN_URL + 'common/logsign.webp'} 
                    alt="Zedock fashion" />
                  <div className="zd-auth-visual-caption">
                    <span className="eyebrow">Member benefits</span>
                    <h3>“Early access, exclusive drops, and styled just for you.”</h3>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

    </div>
  );
}

export default SignUp;
